import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { MediaImageModel } from '@modules/media/models/media-image.model';

@Component({
  selector: 'mb-stage-item',
  templateUrl: './stage-item.component.html',
  styleUrls: ['./stage-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StageItemComponent {
  @Input() topline!: string;
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() media!: MediaImageModel;
  @Input() fuelLabel!: string;
}
